import { render } from "./HitechPage.vue?vue&type=template&id=d0b87cc8&scoped=true"
import script from "./HitechPage.vue?vue&type=script&lang=js"
export * from "./HitechPage.vue?vue&type=script&lang=js"

import "./HitechPage.vue?vue&type=style&index=0&id=d0b87cc8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0b87cc8"]])

export default __exports__